<template>
  <div>
    <table class="table mt-0 table-sm table-hover">
      <thead>
      <tr>
        <th></th>
        <th><input type="checkbox" @change="selectAll"></th>
        <th>ID</th>
        <th>Клиент</th>
        <th>Адрес</th>
        <th>Препараты</th>
        <th></th>
        <th>Вес (гр)</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(o, i) in orders" :key="i">
        <td>{{ (i + 1) + ((paginator.current_page - 1) * paginator.per_page) }}</td>
        <td>
          <input type="checkbox" v-model="selectedOrders[o.id]">
        </td>
        <td>{{ o.id }}
          <p v-if="o.date_order" class="text-muted fs-12">{{ printDate(o.date_order) }}</p>
        </td>
        <td>
          <p>{{ o.client_name }}</p>
          <p v-for="phone in o.order_phones">{{ mixinPrintPhone(phone.phone.phone) }}</p>
        </td>
        <td>
          <p><strong>{{ $AllCities[o.city_id] && $AllCities[o.city_id].name || o.city_id }}</strong></p>
          {{ o.address }}
        </td>
        <td>
          <div v-for="detail in o.details" class="drug_details">
            <p class="flex">
              <v-popover
                v-if="drugsImages[detail.drug_id]"
                class="d-inline"
                placement="bottom"
                :auto-hide="true"
              >
                <i class="icon-fa icon-fa-photo pointer mr-1"></i>
                <template slot="popover">
                  <img :src="drugsImages[detail.drug_id]" alt="">
                </template>
              </v-popover>
              {{ detail.drug.title }} ({{ detail.drug_id }})
              <span v-if="detail.drug.cool" class="ml-1"><i
                class="icon icon-snowflake"/></span>
            </p>
            <p class="text-muted">{{ detail.drug.en_title }}</p>
            <p v-if="detail.drug.pack_comment" class="text-muted">{{ detail.drug.pack_comment }}</p>
            <p v-if="detail.drug.pack_box_comment" class="text-muted">{{ detail.drug.pack_box_comment }}</p>
            <div class="alert alert-warning p-1 mb-1" v-if="(detail.extra_data?.comments ?? []).length">
              <p v-for="c in detail.extra_data.comments">{{ c.text }}</p>
            </div>
            <!--              <i-->
            <!--                v-if="detail.drug.pack_comment"-->
            <!--                v-tooltip="{-->
            <!--                        content: detail.drug.pack_comment,-->
            <!--                        placement: 'bottom-center',-->
            <!--                        classes: ['info'],-->
            <!--                        targetClasses: ['it-has-a-tooltip'],-->
            <!--                        offset: 20,-->
            <!--                        delay: {-->
            <!--                          show: 500,-->
            <!--                          hide: 300-->
            <!--                        }-->
            <!--                      }"-->
            <!--                class="icon-fa icon-fa-info-circle ml-1"-->
            <!--              ></i>-->
            <!--              <i-->
            <!--                v-if="detail.drug.pack_box_comment"-->
            <!--                v-tooltip="{-->
            <!--                        content: detail.drug.pack_box_comment,-->
            <!--                        placement: 'bottom-center',-->
            <!--                        classes: ['info'],-->
            <!--                        targetClasses: ['it-has-a-tooltip'],-->
            <!--                        offset: 20,-->
            <!--                        delay: {-->
            <!--                          show: 500,-->
            <!--                          hide: 300-->
            <!--                        }-->
            <!--                      }"-->
            <!--                class="icon-fa icon-fa-info-circle ml-1"-->
            <!--              ></i>-->
            <template v-if="detail.pack_set !== 1">
              <p><strong>x {{ detail.qty / detail.pack_set }}</strong> (компл)<strong> * {{
                  detail.price * detail.pack_set
                }}</strong></p>
              <p><strong>x {{ detail.qty }}</strong> завод. упак.<strong> * {{ detail.price }}</strong></p>
            </template>
            <template v-else>
              <p><strong>x {{ detail.qty }} * {{ detail.price }}</strong></p>
            </template>
          </div>
        </td>
        <td>
          <span
            :class="{badge: true, 'badge-success': o.pay_method === 3, 'badge-dark': o.pay_method !== 3 }">{{
              o.no_cash_price
            }}</span>
        </td>
        <td>
          <input type="number" v-model="o.pack_weight" @change="updateOrder(o)" placeholder="2000" class="form-control">
          <p class="text-muted fs-12" v-if="o.weight_added_at">{{ printDate(o.weight_added_at) }}</p>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

import api from "@/api";

export default {
  props: ['orders', 'paginator', 'drugsImages'],
  data() {
    return {
      selectedOrders: {},
    }
  },
  computed: {
    $AllCities() {
      return this.$store.getters['platform/cities'];
    },
  },
  methods: {
    selectAll(e) {
      const check = e.target.checked;
      this.orders.forEach((o) => {
        this.selectedOrders[o.id] = check;
      })
      this.selectedOrders = {...this.selectedOrders};
    },
    async updateOrder(order) {
      const {data} = await api.post('/new/orders/updateByAction', {
        action: 'updatePackWeight',
        order_id: order.id,
        pack_weight: order.pack_weight
      })
      if (data.success) {
        toastr['success'](data.message || 'сохранено', 'Успешно')
      } else {
        toastr['warning'](data.message || 'ошибка сервера', 'Неуспешно')
      }
    }
  }
}

</script>
